// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"about_wrapper__cUXL5"};